module.exports = __webpack_public_path__ + "static/media/5.db3b706f.jpg";